export const CONCURRENCY_ERROR =
  "This record was modified by another user. Refresh the page and try again.";

export function getApiErrorMessage(err, fallback = "Something went wrong.") {
  return err?.response?.data?.error || err?.message || fallback;
}

export function isConcurrencyConflict(err) {
  return (
    err?.response?.status === 409 &&
    err?.response?.data?.code === "concurrency_conflict"
  );
}
